// extracted by mini-css-extract-plugin
module.exports = {"white":"#FFFFFF","mainFontFamily":"'proxima-nova', 'Helvetica Neue', helvetica, arial, sans-serif","mainContainer":"adhoc_mainContainer__328_Q","header":"adhoc_header__3TwA_"};